<template>
  <a :href="newsInfo.url" :click_report_50bang="newsInfo.click_report_50bang" class="hovers" :provider="newsInfo.provider" target="_blank" curType="right" style="width: 100%;display: block;width: 243px;" @click="clickReport()">
    <div class="img">
      <div><img :src="newsInfo.pic"></div>
    </div>
    <div class="rt-news">
      <div class="news-title" v-text="newsInfo.title"></div>
    </div>
  </a>
</template>
<script>
import stats from '../../api/statistics'
export default {
  name: 'NewsTplRightSingle',
  props: ['newsInfo'],
  methods: {
    clickReport () {
      if (this.newsInfo.hasOwnProperty('click_report_50bang')) {
        stats.ajax99(this.newsInfo.click_report_50bang);
      }
    }
  }
}
</script>
